import { isEmpty, uniq } from 'lodash/fp';

import { DataResponse, TimeUnitKey } from '../../../types';
import sortTimeUnits from './sort-time-units';

const getDataResponseTimeUnits = (
    dataResponse: DataResponse,
    timeUnitKey: TimeUnitKey
): number[] | string[] => {
    if (isEmpty(dataResponse?.columns) || isEmpty(dataResponse?.records)) {
        return [];
    }

    const { columns, records } = dataResponse;

    const timeUnitIdx = columns.indexOf(timeUnitKey);

    if (timeUnitIdx === -1) {
        return [];
    }

    const timeUnits = uniq(records.map((record) => record[timeUnitIdx])) as number[] | string[];

    return sortTimeUnits(timeUnits, timeUnitKey);
};

export default getDataResponseTimeUnits;
